module.exports = __webpack_public_path__ + "img/marker--smile.95baf41.svg";